// Icônes du widget « Planning semaine en cours », exportées depuis le design system Figma.
// Les tracés à trait unique héritent de `currentColor` pour être recolorés par leur conteneur.

export function CalendarIcon({ className }: { className?: string }) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" className={className} aria-hidden>
      <g
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        transform="translate(2.25 1.25)"
      >
        <path d="M13.75 0.75V4.75M5.75 0.75V4.75" />
        <path d="M10.75 2.75H8.75C4.97876 2.75 3.09315 2.75 1.92157 3.92157C0.75 5.09315 0.75 6.97876 0.75 10.75V12.75C0.75 16.5212 0.75 18.4069 1.92157 19.5784C3.09315 20.75 4.97876 20.75 8.75 20.75H10.75C14.5212 20.75 16.4069 20.75 17.5784 19.5784C18.75 18.4069 18.75 16.5212 18.75 12.75V10.75C18.75 6.97876 18.75 5.09315 17.5784 3.92157C16.4069 2.75 14.5212 2.75 10.75 2.75Z" />
        <path d="M0.75 8.75H18.75" />
        <path
          d="M9.74551 12.75H9.75449M9.74551 16.75H9.75449M13.741 12.75H13.75M5.75 12.75H5.75897M5.75 16.75H5.75897"
          strokeWidth="2"
        />
      </g>
    </svg>
  )
}

// Cadran de pointage : même glyphe pour les trois états, seule la couleur change.
export function ClockGlyph({ size = 12, className }: { size?: number; className?: string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 12 12"
      fill="none"
      className={className}
      aria-hidden
    >
      <path
        d="M6 11C8.76142 11 11 8.76142 11 6C11 3.23858 8.76142 1 6 1C3.23858 1 1 3.23858 1 6C1 8.76142 3.23858 11 6 11Z"
        stroke="currentColor"
      />
      <path d="M6 4V6L7 7" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

// Trois barres empilées : la pastille « Affluence » de la légende.
export function AffluenceIcon({ className }: { className?: string }) {
  return (
    <svg width="13" height="11" viewBox="0 0 13 11" fill="none" className={className} aria-hidden>
      <path d="M1.5 1.5L11.5 1.5" stroke="#A4C494" strokeWidth="3" strokeLinecap="round" />
      <path d="M1.5 5.5L11.5 5.5" stroke="#86AB7D" strokeWidth="3" strokeLinecap="round" />
      <path d="M1.5 9.5L11.5 9.5" stroke="#6A9560" strokeWidth="3" strokeLinecap="round" />
    </svg>
  )
}

export function LocationUserIcon({ className }: { className?: string }) {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" className={className} aria-hidden>
      <g stroke="currentColor" strokeWidth="1.5" transform="translate(2.25 0.75)">
        <path
          d="M1.89988 12C0.8335 13.5047 0.564743 14.2989 0.864835 14.9367C0.894572 14.9999 0.929388 15.0609 0.968984 15.1192C1.39772 15.75 2.50576 15.75 4.72185 15.75H8.77801C10.9941 15.75 12.1021 15.75 12.5309 15.1192C12.5705 15.0609 12.6053 14.9999 12.635 14.9367C12.9351 14.2989 12.6668 13.5047 11.6004 12"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M7.49851 4.5H6.00135C3.8489 4.5 2.39769 6.80182 3.24558 8.87102C3.36369 9.15926 3.63468 9.34615 3.93452 9.34615H4.46176C4.63947 9.34615 4.79437 9.47265 4.83747 9.65297L5.51622 12.4925C5.65775 13.0846 6.1664 13.5 6.74993 13.5C7.33346 13.5 7.84211 13.0846 7.98364 12.4925L8.66239 9.65297C8.70549 9.47265 8.86039 9.34615 9.0381 9.34615H9.56534C9.86518 9.34615 10.1362 9.15926 10.2543 8.87102C11.1022 6.80182 9.65096 4.5 7.49851 4.5Z" />
        <path d="M8.62493 2.625C8.62493 3.66053 7.78546 4.5 6.74993 4.5C5.7144 4.5 4.87493 3.66053 4.87493 2.625C4.87493 1.58947 5.7144 0.75 6.74993 0.75C7.78546 0.75 8.62493 1.58947 8.62493 2.625Z" />
      </g>
    </svg>
  )
}

export function ComputerUserIcon({ className }: { className?: string }) {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" className={className} aria-hidden>
      <g
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
        transform="translate(0.875 1.625)"
      >
        <path d="M9.625 14.125H11.125M6.625 14.125C7.24632 14.125 7.75 13.6213 7.75 13V11.125L8.125 11.125L8.5 11.125V13C8.5 13.6213 9.00368 14.125 9.625 14.125M9.625 14.125H6.625M6.625 14.125H5.125M8.125 11.125V14.125" />
        <path d="M11.125 0.625H5.125C3.00368 0.625 1.94302 0.625 1.28401 1.28401C0.625 1.94302 0.625 3.00368 0.625 5.125V6.625C0.625 8.74632 0.625 9.80698 1.28401 10.466C1.94302 11.125 3.00368 11.125 5.125 11.125H11.125C13.2463 11.125 14.307 11.125 14.966 10.466C15.625 9.80698 15.625 8.74632 15.625 6.625V5.125C15.625 3.00368 15.625 1.94302 14.966 1.28401C14.307 0.625 13.2463 0.625 11.125 0.625Z" />
        <path d="M8.125 6.25C8.95343 6.25 9.625 5.57843 9.625 4.75C9.625 3.92157 8.95343 3.25 8.125 3.25C7.29657 3.25 6.625 3.92157 6.625 4.75C6.625 5.57843 7.29657 6.25 8.125 6.25ZM8.125 6.25C6.88236 6.25 5.875 7.25736 5.875 8.5M8.125 6.25C9.36764 6.25 10.375 7.25736 10.375 8.5" />
      </g>
    </svg>
  )
}

export function DoorIcon({ className }: { className?: string }) {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" className={className} aria-hidden>
      <g
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        transform="translate(2.25 0.75)"
      >
        <path d="M11.25 14.25C12.0784 14.25 12.75 13.5784 12.75 12.75V3.75C12.75 2.92156 12.0784 2.25 11.25 2.25" />
        <path d="M0.75 4.38577V12.1142C0.75 13.3091 0.75 13.9065 1.09838 14.3232C1.44675 14.7398 2.03562 14.8467 3.21335 15.0604L5.46335 15.4688C7.1026 15.7663 7.92225 15.915 8.46112 15.4661C9 15.0172 9 14.1857 9 12.5225V3.97742C9 2.31432 9 1.48277 8.46112 1.03385C7.92225 0.584934 7.10261 0.733687 5.46334 1.03119L3.21335 1.43954C2.03561 1.65328 1.44675 1.76015 1.09838 2.17681C0.75 2.59348 0.75 3.19091 0.75 4.38577Z" />
        <path d="M6.375 8.24869L6.375 8.24119" strokeWidth="2" />
      </g>
    </svg>
  )
}

export function TruckDeliveryIcon({ className }: { className?: string }) {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" className={className} aria-hidden>
      <g
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
        transform="translate(0.375 1.375)"
      >
        <circle cx="8.125" cy="7.62511" r="1" />
        <circle cx="3.125" cy="7.62511" r="1" />
        <path d="M2.125 7.61134C1.57664 7.584 1.23455 7.50243 0.991117 7.259C0.747682 7.01556 0.666109 6.67348 0.638775 6.12511M4.125 7.62511H7.125M9.125 7.61134C9.67336 7.584 10.0154 7.50243 10.2589 7.259C10.625 6.89288 10.625 6.30362 10.625 5.12511V4.12511H8.275C7.90274 4.12511 7.71662 4.12511 7.56598 4.07617C7.26155 3.97725 7.02286 3.73857 6.92394 3.43413C6.875 3.2835 6.875 3.09737 6.875 2.72511C6.875 2.16673 6.875 1.88754 6.80158 1.66159C6.65321 1.20493 6.29518 0.846905 5.83853 0.698529C5.61258 0.625113 5.33338 0.625113 4.775 0.625113H0.625" />
        <path d="M0.625 2.62511L3.625 2.62511" />
        <path d="M0.625 4.12511L2.625 4.12511" />
        <path d="M6.875 1.62511H7.78561C8.51328 1.62511 8.87712 1.62511 9.17321 1.80197C9.46931 1.97882 9.6418 2.29917 9.98679 2.93986L10.625 4.12511" />
      </g>
    </svg>
  )
}
